<template>
  <div class="fabric-composition">
    <div v-for="(row, index) in value" :key="index" class="fabric-line">
      <el-autocomplete
        :value="row.name"
        :fetch-suggestions="suggest"
        placeholder="材质成分"
        :disabled="disabled"
        @input="set(index, 'name', $event)" />
      <el-input :value="row.percent" placeholder="占比" :disabled="disabled" @input="set(index, 'percent', $event)">
        <template slot="append">%</template>
      </el-input>
      <button type="button" class="plain" :disabled="disabled" @click="remove(index)">删除</button>
    </div>
    <button
      type="button"
      class="plain"
      :disabled="disabled || value.length >= 100"
      @click="$emit('input', [...value, { name: '', percent: '' }])">
      添加成分
    </button>
    <span :class="{ 'fabric-invalid': total !== 10000 }">
      合计 {{ total === null ? '—' : total / 100 }}%（必须为100%）
    </span>
    <small v-if="duplicates" class="fabric-invalid">成分重复，请合并后填写</small>
  </div>
</template>
<script>
export default {
  props: { value: { type: Array, default: () => [] }, names: { type: Array, default: () => [] }, disabled: Boolean },
  computed: {
    total() {
      if (!this.value.length) return null
      let total = 0
      for (const row of this.value) {
        if (!/^(?:0|[1-9][0-9]{0,2})(?:\.[0-9]{1,2})?$/.test(row.percent)) return null
        const [whole, fraction = ''] = row.percent.split('.')
        total += Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
      }
      return total
    },
    duplicates() {
      const names = this.value.map((row) => row.name.trim()).filter(Boolean)
      return new Set(names).size !== names.length
    }
  },
  methods: {
    suggest(text, done) {
      done(
        this.names
          .filter((name) => name.includes(text))
          .slice(0, 30)
          .map((value) => ({ value }))
      )
    },
    set(index, key, value) {
      this.$emit(
        'input',
        this.value.map((row, i) => (i === index ? { ...row, [key]: value } : { ...row }))
      )
    },
    remove(index) {
      this.$emit(
        'input',
        this.value.filter((row, i) => i !== index).map((row) => ({ ...row }))
      )
    }
  }
}
</script>
<style scoped>
.fabric-composition {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  font-size: 12px;
}
.fabric-line {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.fabric-line > .el-autocomplete {
  width: 180px;
  max-width: 100%;
}
.fabric-line > .el-input {
  width: 115px;
  max-width: 100%;
}
.fabric-invalid {
  color: #d84a48;
}
.fabric-composition button {
  align-self: flex-start;
}
.fabric-composition ::v-deep .el-input__inner {
  font-size: 11px;
  height: 30px;
  line-height: 30px;
}
</style>
<style scoped>
.fabric-composition button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
  cursor: pointer;
}
.fabric-composition button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.fabric-composition ::v-deep .el-input-group__append {
  padding: 0 8px;
}
</style>
